import { render, staticRenderFns } from "./WhatsappIcon.vue?vue&type=template&id=cbc9393e&"
import script from "./WhatsappIcon.vue?vue&type=script&lang=js&"
export * from "./WhatsappIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports